var React = require('react');

function Bj (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"gray","d":"M67.6-154h666v666h-666z"}))),React.createElement("g",{"clipPath":"url(#a)","transform":"matrix(.961 0 0 .7207 -65 111)","key":1},React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#319400","d":"M0-154h333v666H0z","key":0}),React.createElement("path",{"fill":"#ffd600","d":"M333-154h666v333H333z","key":1}),React.createElement("path",{"fill":"#de2110","d":"M333 179h666v333H333z","key":2})]))]);
}

Bj.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bj;

Bj.default = Bj;
